export default "__VITE_ASSET__BvUBi7AV__"